import { TransactionStatus } from "../../setup/api/services/contract/models";
import { ETransferRequesterType } from "../../setup/api/services/completed-transfers/models";

export const HEADER = "تم التحويل v2";
export const COMPLETED_TRANSFERS_TAB = "تم التحويل v2";

export const TABLE_HEADERS = {
  USERNAME: "المستخدم",
  BENEFICIARY_ID: "رمز المستخدم",
  REQUESTER_NAME: "منفّذ التحويل",
  REQUESTER_ID: "رمز المنفّذ",
  REQUESTER_TYPE: "نوع المنفّذ",
  STATUS: "الحالة",
  DOMAIN_ID: "رمز المعاملة",
  TRANSACTION_ID: "رمز الحركة",
  GATEWAY_PAYMENT_ID: "الرقم المرجعي",
  REFERENCE_TRANSACTION_ID: "رمز الدفع المرجعي",
  AMOUNT: "القيمة",
  TRANSFER_CHANNEL: "تمت عبر",
  TRANSFER_TYPE: "النوع",
  MANUAL_WITHDRAW: "طلب السحب",
  CREATED_AT: "وقت الإنشاء",
  TRANSFER_TIME: "وقت التحويل",
};

/** Statuses a transfer can be filtered by. Empty value means every status. */
export const STATUS_FILTER_ALL = "";

export const STATUS_FILTER_OPTIONS: {
  value: TransactionStatus | typeof STATUS_FILTER_ALL;
  label: string;
}[] = [
  { value: STATUS_FILTER_ALL, label: "كل الحالات" },
  { value: TransactionStatus.SUCCESS, label: "تم التحويل" },
  { value: TransactionStatus.COMPLETED, label: "مكتملة" },
  { value: TransactionStatus.PENDING, label: "بانتظار التحويل" },
  { value: TransactionStatus.IN_PROGRESS, label: "قيد التنفيذ" },
  { value: TransactionStatus.INITIATED, label: "تم البدء" },
  { value: TransactionStatus.FAILED, label: "فشل التحويل" },
];

export const REQUESTER_TYPE_LABELS: Record<string, string> = {
  [ETransferRequesterType.USER]: "مستخدم",
  [ETransferRequesterType.ADMIN]: "مشرف",
  [ETransferRequesterType.SERVICE]: "خدمة آلية",
};

export const AUTO_CASH_OUT_SERVICE_LABEL = "خدمة التحويل التلقائي";

/** Shown wherever the backend has not sent a value for a field yet. */
export const EMPTY_VALUE = "-";
